import * as types from '@/common/types/mutation.js'
// initial state
const state = {
    baoRecords : {}
}

// getters
const getters = {
    getBaoRecords(type){
        return state.baoRecords[type]
    }
}

// actions
const actions = {
    setBaoRecords(type,values) {
        state.baoRecords[type] = values
    }
}

// mutations
const mutations = {
    [types.BAO_RECORDS](state,record) {
        state.baoRecords = record
    },
    [types.BAO_RECORDS_TYPE](state,record) {
        state.baoRecords[record.type] = record.data
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}